<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>Map Layers</a>
      </li>
    </ol>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-2">
        <div class="card-body">
          <div class="d-flex fw-bold small mb-3">
            <span class="flex-grow-1">
              <button (click)="this.clearItem();this.updateItemModal.show()" class="btn btn-outline-default">Add New Layer</button>
            </span>                    
          </div>
          <table class="table table-striped"> 
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col" class="d-none d-xl-table-cell">Path</th>
                <th scope="col" class="d-none d-lg-table-cell ">Type</th>
                <th scope="col" class="d-none d-lg-table-cell ">Layer Name</th>
                <th scope="col" class="d-none d-lg-table-cell ">Visible</th>
                <th scope="col" class="d-none d-lg-table-cell " *ngIf="app.applicationAllowed('fire-foresight')">Fire Foresight</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="service.loading">
                <td colspan="10"><div class="spinner-border"></div></td>
              </tr>
              <tr *ngFor="let list of remoteData | async">
                <td>{{list.mapLayerId}}</td>
                <td>{{list.layerName}}</td>
                <td class="d-none d-xl-table-cell">{{list.path}}</td>
                <td class="d-none d-lg-table-cell">{{list.layerType}}</td>
                <td class="d-none d-lg-table-cell">{{list.fileLayerName}}</td>
                <td class=""><i *ngIf="list.visible" class="fa fa-check"></i></td>
                <td class="" *ngIf="app.applicationAllowed('fire-foresight')"><i *ngIf="list.includeInFireForesight" class="fa fa-fire"></i></td>
                <td>
                  <a class="btn btn-outline-default" (click)="item=list;copyLayer(list);updateItemModal.show()"><i class="fa fa-copy"></i></a>
                  &nbsp;

                  <!-- edit template -->
                  <a class="btn btn-outline-default" (click)="item=list;updateItemModal.show()"><i class="fa fa-pencil"></i></a>
                  <!-- delete -->
                  &nbsp;
                  <a class="btn btn-outline-danger ml-2" (click)="removeItem(list)"><i class="fa fa-trash"></i></a>

                </td>
              </tr>
            </tbody>
          </table>
        </div>  
      </div>
    </div>
  </div>
</div>  

<div class="modal fade" bsModal #updateItemModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="item">
      <div class="modal-header">
        <h5 class="modal-title">Update Item : {{item.layerName}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="updateItemModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Layer Name</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="item.layerName" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Path</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="item.path" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label>Type</label>
              <div class="input-group m-b">
                <select [(ngModel)]="item.layerTypeId" class="form-control form-select">
                  <option value="1">GeoJSON</option>
                  <option value="2">Keyhole Markup Language (KML)</option>
                  <option value="3">ESRI</option>
                  <option value="4">Common Alerting Protocol (CAP)</option>
                  <option value="5">Web Mapping Service (WMS)</option>
                  <option value="7">Tile Map</option>
                  <option value="8">WA Emergency JSON</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="item.layerTypeId == 5">
            <div class="form-group input-group-sm">
              <label>Layer Name (WMS)</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="item.fileLayerName" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="item.layerTypeId == 5">
            <div class="form-group input-group-sm">
              <label>Styles (WMS)</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="item.styles" class="form-control"/>
              </div>
            </div>
          </div>

          <div class="col-sm-8" *ngIf="item.layerTypeId == 1">
            <div class="form-group input-group-sm">
              <label></label>
              <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" id="newEnabled" [(ngModel)]="item.overwriteStyles">
                <label class="form-check-label" for="newEnabled">Overwrite Styles</label>
              </div>
            </div>
            <div class="form-group input-group-sm" style="margin:10px" *ngIf="item.overwriteStyles">
              <app-key-value-editor [config]="geoJsonStyleConfig" [(json)]="item.styles" (jsonChange)="updateStyles(item, $event)"></app-key-value-editor>
            </div>
          </div>
          
          <div class="col-sm-4" *ngIf="item.layerTypeId == 5">
            <div class="form-group input-group-sm">
              <label>Tyle Size (WMS)</label>
              <div class="input-group m-b">
                  <select [(ngModel)]="item.tileSize" class="form-select">
                    <option value="256">256</option>
                    <option value="512">512</option>
                    <option value="1024">1024</option>
                    <option value="2048">2048</option>
                  </select>
              </div>
            </div>
          </div>
        </div>  
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label></label>
              <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" id="newEnabled" [(ngModel)]="item.visible">
                <label class="form-check-label" for="newEnabled">Visible</label>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group input-group-sm">
              <label></label>
              <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" id="newEnabled" [(ngModel)]="item.useProxy">
                <label class="form-check-label" for="newEnabled">Use Proxy</label>
              </div>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="app.applicationAllowed('fire-foresight')">
            <div class="form-group input-group-sm">
              <label></label>
              <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" id="newEnabled" [(ngModel)]="item.includeInFireForesight">
                <label class="form-check-label" for="newEnabled">Include in Forest Foresight</label>
              </div>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="item.useProxy">
            <div class="form-group input-group-sm">
              <label>Auth Token</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="item.authToken" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group input-group-sm">
              <label>URL</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="item.url" class="form-control"/>
              </div>
            </div>
          </div>
      </div>
      <div class="modal-footer">
        <button (click)="updateItemModal.hide()" class="btn btn-white">Cancel</button>
        <button *ngIf="item.mapLayerId != null" (click)="updateItem();updateItemModal.hide()" class="btn btn-white">Update</button>
        <button *ngIf="item.mapLayerId == null" (click)="addItem();updateItemModal.hide()" class="btn btn-white">Add</button>
      </div>
    </div>
  </div>
</div>

  